import React from 'react';

import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';

type ErrorType = { error: string };

export const renderErrorTable = (validationErrors: ErrorType[]) => (
  <DataTable value={validationErrors} className="mb-2" scrollHeight="63vh">
    <Column field="error" header="Название ошибки" />
  </DataTable>
);
